<template>
  <div class="wrap talk">
    <header>
      <h1><a href="#" class="logo"></a></h1>
    </header>
    <div class="container">
      <main class="content">
        <article class="certification">
          <section
            class="txt agree-bg"></section>
          <section>
            <div class="box row row_c row_jsc">
              <span><i class="xi-check"></i></span>
              <h2>판매 취소 접수</h2>
              <br/>
              <h4>진단 결과가 만족스럽지 못하셨나요?</h4>
              <br/>
              <p>아쉽지만, 판매 취소 접수할게요.</p>
              <p>신청 시 남기신 주소로 중고폰이 반송될 예정이에요.</p>
              <br/>
              <p>다음에 또 민팃에서 만나요!</p>
              <br/>
              <br/>
              <br/>
            </div>
          </section>
        </article>
        <div class="cs-center row row_ac row_jsc">
          <span class="qa">고객센터 문의 </span>
          <span><a href="tel:1877-5446" class="en phone">1877-5446</a></span>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import AppConfig from '@/config'

export default {
  name: 'saleCnclComplete',
  components: {},
  data: () => ({
    rs_data: [],
    ordNum: null
  }),
  computed: {},
  async mounted () {
    this.ordNum = decodeURIComponent(this.$route.query.ordNum).trim();
    await this.saleAgrmCnclInit()
    await this.SaleCncl()
  },
  methods: {
    async saleAgrmCnclInit () {
      const rtn = await Vue.httpClient
        .get(`/api/purchase/pcs/mgmt/public/ord-num?ordNum=${this.ordNum}&masking=false`, )
        .then((res) => {
          if (res.data.status === AppConfig.HTTP_RESPONSE_SUCCESS) {
            if (res.data.result) {
              this.rs_data = res.data.result
            } else {
              Vue.Alert.alert('매입정보가 없습니다!').then(() => {
                this.closeBrowserOrGoBack()
              })
            }
          } else {
            Vue.Alert.alert('통신 오류 입니다.').then(() => {
              this.closeBrowserOrGoBack()
            })
          }
        })
    },

    async SaleCncl () { 

      const { data } = await this.$http.post(
        '/api/purchase/pcs/mgmt/public/sale-cncl',
        this.rs_data
      )
      if (data.status === AppConfig.HTTP_RESPONSE_SUCCESS) {
        if(data.result.talkMobileMsg !== '반품 요청이 완료되었습니다.'){
          this.$Alert.alert(data.result.talkMobileMsg).then(() => {
          this.closeBrowserOrGoBack()
        })
        }
      } else {
        this.$Alert.alert('판매취소 요청 실패하였습니다!').then(() => {
          this.closeBrowserOrGoBack()
        })
      }
    },

    closeBrowserOrGoBack () {
      const userAgent = navigator.userAgent.toLowerCase()

      if (userAgent.includes('kakaotalk')) {
        location.href = 'kakaotalk://inappbrowser/close'
      } else {
        window.history.back()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/purchase/saleCnclComplete.vue